import { useState } from "react"
import { Box, Grid } from "@mui/material"
import BaseImage from "../../components/BaseImage"
import SignUpStepper from "../../components/SignUp/SignUpStepper"
import PinCodeForm from "../../components/SignUp/PinCodeForm"
import SignUpForm from "../../components/SignUp/SignUpForm"
import UserInfoForm from "../../components/SignUp/UserInfoForm"
import UserSubjectForm from "../../components/SignUp/UserSubjectForm"
import ClinicForm from "../../components/SignUp/ClinicForm"
import LeftSideBanner from "../../assets/images/auth/left_side_banner.svg"
import LogoColor from "../../assets/images/logo/dDNA_logo_fullwtagline_color.svg"
import LogoWhite from "../../assets/images/logo/dDNA_logo_white.svg"

const STEPS = [
  '',
  '',
  '',
  '',
  ''
];

const SignUp = () => {
  const [activeStep, setActiveStep] = useState(0)
  const [kitCode, setKitCode] = useState('')
  const [infoFormStates, setInfoFormStates] = useState()

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid
          item
          xs={6}
          sx={{
            display: { xs: 'none', md: 'block' }
          }}
        >
          <Box
            sx={{
              padding: '8px',
              width: '100%',
              height: '100%',
            }}
          >
            <Box
              sx={{
                width: '100%',
                height: '100%',
                bgcolor: 'primary.black',
                borderRadius: '10px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                position: 'relative'
              }}
            >
              <BaseImage
                src={LogoWhite}
                sx={{
                  width: '140px',
                  mt: '137px'
                }}
              />
              <BaseImage
                sx={{
                  width: '610px',
                  height: 'auto',
                  position: 'absolute',
                  right: 0,
                  bottom: 0
                }}
                sximage={{
                  objectFit: 'cover'
                }}
                src={LeftSideBanner} alt='left-side-banner' 
              />
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box
            sx={{
              padding: '20px',
              display: 'flex',
              justifyContent: 'center',
              height: '100vh',
              overflowY: 'auto',
            }}
          >
            <Box sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              width: '390px',
              padding: '20px'
            }}>
              <BaseImage
                sx={{
                  mt: { md: '20px' },
                  width: '158px'
                }}
                src={LogoColor}
              />
              <Box sx={{
                mt: '20px'
              }}>
                <SignUpStepper activeStep={activeStep} steps={STEPS} />
              </Box>
              {activeStep === 0 && <PinCodeForm setKitCode={setKitCode} onNextStep={() => setActiveStep(activeStep + 1)} />}
              {activeStep === 1 && <SignUpForm onNextStep={() => setActiveStep(activeStep + 1)} />}
              {activeStep === 2 && (
                <UserInfoForm
                  onNextStep={() => setActiveStep(activeStep + 1)}
                  infoFormStates={infoFormStates}
                  setInfoFormStates={setInfoFormStates}
                />
              )}
              {activeStep === 3 && (
                <UserSubjectForm
                  kitCode={kitCode}
                  onNextStep={() => setActiveStep(activeStep + 1)}
                  infoFormStates={infoFormStates}
                  setInfoFormStates={setInfoFormStates} 
                />
              )}
              {activeStep === 4 && (
                <ClinicForm
                  kitCode={kitCode}
                  infoFormStates={infoFormStates}
                />
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </Box>
  )
}

export default SignUp